import Create from "./Create";
import Update from "./Update";
import showAll from "./showAll";
import Delete from "./Delete"

const blog = { Update, showAll,Create,Delete };

export default blog;

export {
    Create,
    Update,
    showAll,
    Delete,
}